/**
 * Visszaadja két dátum közötti napok, órák, percek és másodpercek számát.
 * @param {string} baseDate - Az alap dátum, ahonnan számolunk.
 * @param {string} targetDate - A cél dátum, ameddig számolunk.
 * @returns {{ days: number, hours: number, minutes: number, seconds: number }} A két dátum közötti napok, órák, percek és másodpercek száma.
 */
module.exports.getDatePartsBetweenDates = function getDatePartsBetweenDates (baseDate, targetDate) {
  const now = (new Date(baseDate)).getTime()
  const target = (new Date(targetDate)).getTime()
  const difference = target - now

  if (difference < 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24))
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((difference % (1000 * 60)) / 1000)

  return {
    days,
    hours,
    minutes,
    seconds
  }
}
